import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'environments/environment';

export interface Study {
  id?: string;
  code: string;
  description?: string;
  sponsor?: string;
  status?: string;
  createdAt?: string;
  updatedAt?: string;
}

@Injectable({
  providedIn: 'root'
})
export class StudyService {
  private http = inject(HttpClient);
  private apiUrl = (environment.api_gateway && environment.api_gateway !== 'undefined' ? environment.api_gateway : 'http://localhost:3000') + '/api/inventories/studies';

  constructor() {}

  getAll() {
    return this.http.get<any>(this.apiUrl);
  }

  generate(itemId: string, tagId?: string) {
    return this.http.post<any>(`${this.apiUrl}/generate`, { itemId, tagId });
  }
}
